// src/utils/subscriptionApiMock.ts
// Temporary mock data for testing the UI before backend is ready

import { SubscriptionPlan, Subscription, Invoice } from './subscriptionApi';

// Mock subscription plans
export const mockPlans: SubscriptionPlan[] = [
  {
    id: 'plan-team',
    name: 'Team',
    description: 'Medium-sized teams or training groups',
    priceId: 'price_team',
    price: 24900, // $249
    currency: 'usd',
    interval: 'month',
    features: [
      'Up to 200 athletes',
      'Team management tools',
      'Priority support',
      'Advanced analytics'
    ],
    recommended: false
  },
  {
    id: 'plan-program',
    name: 'Program',
    description: 'Large programs or multi-team organizations',
    priceId: 'price_program',
    price: 39000, // $390
    currency: 'usd',
    interval: 'month',
    features: [
      'Up to 2,000 athletes',
      'Multi-team organization support',
      'Dedicated account manager',
      'Custom integrations',
      'Advanced reporting',
      '24/7 support'
    ],
    recommended: false
  }
];

// Mock active subscription
export const mockSubscription: Subscription = {
  id: 'sub-mock-123',
  status: 'active',
  planTier: 'team',
  planName: 'Team',
  currentPeriodStart: new Date().toISOString(),
  currentPeriodEnd: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days from now
  cancelAtPeriodEnd: false,
  trialEnd: null,
  amount: 24900,
  currency: 'usd',
  interval: 'month'
};

// Mock invoices
export const mockInvoices: Invoice[] = [
  {
    id: 'in-1',
    amountPaid: 24900,
    currency: 'usd',
    status: 'paid',
    created: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days ago
    invoicePdf: null,
    hostedInvoiceUrl: 'https://example.com/invoice-1'
  },
  {
    id: 'in-2',
    amountPaid: 24900,
    currency: 'usd',
    status: 'paid',
    created: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(), // 60 days ago
    invoicePdf: null,
    hostedInvoiceUrl: 'https://example.com/invoice-2'
  }
];

// Check if we should use mock data (when backend is not available)
export const useMockData = process.env.REACT_APP_USE_MOCK_SUBSCRIPTION === 'true';

